import React from "react";
import { withStyles } from "@material-ui/core";
import FaceIcon from "@material-ui/icons/Face";
import WorkIcon from "@material-ui/icons/Work";
import { Classes, createStyles } from "@theme";
import { ChipArray } from "@components/ChipArray";

export type CustomerCommentBoxHeaderProps = {
  areasOfExpertise: string[];
  contactPersons: Array<{ label: string; value: string }>;
  onRemoveAreaOfExpertise: (v: string) => void;
  onRemoveContactPerson: (v: string) => void;
};

type Props = CustomerCommentBoxHeaderProps & {
  classes: Classes<typeof styles>;
};

class CustomerCommentBoxHeader extends React.Component<Props> {
  static defaultProps: Partial<CustomerCommentBoxHeaderProps> = {
    areasOfExpertise: [],
    contactPersons: []
  };

  render() {
    const chips = [];

    chips.push(
      ...this.props.areasOfExpertise.map((item) => ({
        label: item,
        key: item,
        icon: <WorkIcon />,
        onDelete: () => this.props.onRemoveAreaOfExpertise(item)
      }))
    );

    chips.push(
      ...this.props.contactPersons.map((item) => ({
        label: item.label,
        key: item.value,
        icon: <FaceIcon />,
        onDelete: () => this.props.onRemoveContactPerson(item.value)
      }))
    );

    return (
      <div className={this.props.classes.root}>
        <ChipArray items={chips} />
      </div>
    );
  }
}

const styles = createStyles((theme) => ({
  root: {
    display: "flex",
    padding: theme.spacing(1 / 2),
    marginLeft: -theme.spacing(),
    marginBottom: theme.spacing(1 / 2)
  }
}));

export default withStyles(styles)(CustomerCommentBoxHeader);
